import { render, staticRenderFns } from "./ModalParticipants.vue?vue&type=template&id=560e607c&scoped=true&"
import script from "./ModalParticipants.vue?vue&type=script&lang=js&"
export * from "./ModalParticipants.vue?vue&type=script&lang=js&"
import style0 from "./ModalParticipants.vue?vue&type=style&index=0&id=560e607c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e607c",
  null
  
)

export default component.exports